import { useLanguage } from '../contexts/LanguageContext.jsx'

function visiblePages(page, totalPages) {
  if (totalPages <= 5) {
    return Array.from({ length: totalPages }, (_, index) => index + 1)
  }
  const start = Math.max(1, Math.min(page - 2, totalPages - 4))
  return Array.from({ length: 5 }, (_, index) => start + index)
}

function Pagination({ pagination, onPageChange, disabled = false }) {
  const { t } = useLanguage()
  if (!pagination || pagination.totalPages <= 1) return null

  const changePage = (event, nextPage) => {
    event.currentTarget.blur()
    onPageChange(nextPage)
  }

  const pages = visiblePages(pagination.page, pagination.totalPages)
  return (
    <nav className="pagination" aria-label={t('pagination.aria')}>
      <button
        type="button"
        onClick={(event) => changePage(event, pagination.page - 1)}
        disabled={disabled || !pagination.hasPrev}
      >
        {t('common.previousPage')}
      </button>
      <div className="pagination-pages">
        {pages.map((page) => (
          <button
            className={page === pagination.page ? 'is-active' : ''}
            type="button"
            key={page}
            aria-current={page === pagination.page ? 'page' : undefined}
            onClick={(event) => changePage(event, page)}
            disabled={disabled}
          >
            {page}
          </button>
        ))}
      </div>
      <span className="pagination-summary">
        {t('pagination.summary', {
          page: pagination.page,
          total: pagination.total,
          totalPages: pagination.totalPages,
        })}
      </span>
      <button
        type="button"
        onClick={(event) => changePage(event, pagination.page + 1)}
        disabled={disabled || !pagination.hasNext}
      >
        {t('common.nextPage')}
      </button>
    </nav>
  )
}

export default Pagination
